import React, { useState } from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { Filter, FlexContent, PageHeading, SearchBox } from "../../components";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import InterventionsTable from "./components/InterventionsTable";
import { InterventionStateArray, InterventionTableQuery } from "./models";
import {
  getTableFiltersFromCodebooks,
  getTableParsedFiltersForQuery,
} from "../../helpers/tableHelpers";
import { SelectItem } from "../../components/select/Select";
import { useGetCodebooksQuery } from "../../common/queries";

const defaultTableQuery: InterventionTableQuery = {
  page: 1,
  pageSize: 10,
};

const InterventionsPage: React.FC = (): React.ReactElement => {
  const { tIntervention, tCommon, t } = useCustomTranslation();
  const codebooksQuery = useGetCodebooksQuery();

  const [queryParams, setQueryParams] =
    useState<InterventionTableQuery>(defaultTableQuery);
  const [selectedFilters, setSelectedFilters] = useState<
    Record<string, SelectItem[]>
  >({});

  const handleSearch = (searchPhrase: string) => {
    setQueryParams({ ...queryParams, searchPhrase });
  };

  const handleFilter = (selectedFilters: Record<string, SelectItem[]>) => {
    const parsedFilters = getTableParsedFiltersForQuery(selectedFilters);

    setQueryParams({
      searchPhrase: queryParams.searchPhrase,
      ...defaultTableQuery,
      ...parsedFilters,
    });
    setSelectedFilters(selectedFilters);
  };

  return (
    <ContentWrapper htmlTitle={tCommon("menu_interventions")}>
      <FlexContent className="mb-4">
        <PageHeading title={tIntervention("table_heading")} />
        <FlexContent className="gap-4">
          <Filter
            selectedFitlers={selectedFilters}
            updateFilters={handleFilter}
            filters={[
              ...getTableFiltersFromCodebooks(
                [
                  { key: "categoryId", source: "interventionCategories" },
                  { key: "orderCategoryId", source: "orderCategories" },
                ],
                t,
                codebooksQuery.data,
              ),
              {
                key: "state",
                label: tIntervention("state"),
                options: InterventionStateArray.map((state) => ({
                  value: state,
                  label: tIntervention(`state_${state}`),
                })),
              },
            ]}
          />
          <SearchBox onSearch={handleSearch} />
        </FlexContent>
      </FlexContent>
      <InterventionsTable
        queryParams={queryParams}
        setQueryParams={setQueryParams}
      />
    </ContentWrapper>
  );
};

export default InterventionsPage;
